// src/extenders/store-detail.js
var StoreDetail = class extends HTMLElement {
  constructor() {
    super();
    const toggle = this.querySelector("#additional-opening-times-toggle");
    const curtain = document.querySelector("#curtain");
    const close = this.querySelector("#store-opening-times-close");
    if (toggle) {
      toggle.addEventListener("click", () => {
        const modal = this.querySelector("#store-detail-modal");
        modal == null ? void 0 : modal.setAttribute("aria-hidden", "false");
        curtain == null ? void 0 : curtain.setAttribute("aria-hidden", "false");
      });
    }
    curtain.addEventListener("click", () => {
      const modal = this.querySelector("#store-detail-modal");
      modal == null ? void 0 : modal.setAttribute("aria-hidden", "true");
      curtain == null ? void 0 : curtain.setAttribute("aria-hidden", "true");
    });
    close == null ? void 0 : close.addEventListener("click", () => {
      const modal = this.querySelector("#store-detail-modal");
      modal == null ? void 0 : modal.setAttribute("aria-hidden", "true");
      curtain == null ? void 0 : curtain.setAttribute("aria-hidden", "true");
    });
  }
};
if (!customElements.get("store-detail")) {
  customElements.define("store-detail", StoreDetail);
}
